import { Component } from '@angular/core';
import { NavController,AlertController,App } from 'ionic-angular';

import { StorageService } from '../../../providers/service/storageservice';
import { LoginPage } from '../../login/login/login';
import { AppState } from '../../../app/app.global';
import { WebService } from '../../../providers/service/webservice';

/**
 * Generated class for the OnecardPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-onecard',
  templateUrl: 'onecard.html',
})
export class OnecardPage {
  user:any =null;
	constructor (private alertCtrl: AlertController,public appCtrl: App,public global: AppState,private webService:WebService) {
		this.user = StorageService.getObj('currentUser');
		//修改密码时判断是否登录，未登录跳转到登录地址
		if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
      		StorageService.remove('currentUser');
      		this.appCtrl.getRootNav().push(LoginPage);
    	}
	}


}



// WEBPACK FOOTER //
// ./src/pages/about/onecard/onecard.ts